import { observer } from 'mobx-react-lite'
import type { QuestionsBuilderViewModel } from '@/features/legends/questions/QuestionsBuilderViewModel'
import {
  type ToolboxGroup,
  Toolbox,
} from '@/features/legends/questions/components/Toolbox'
import { toolboxTypes } from '@/features/legends/questions/question-types'

const testId = 'legend-toolbox'

const groups: ToolboxGroup[] = [
  {
    title: 'Elements',
    items: toolboxTypes.elements.map((t) => ({
      type: t.type,
      title: t.friendlyType,
    })),
  },
  {
    title: 'Meta',
    items: toolboxTypes.meta.map((t) => ({
      type: t.type,
      title: t.friendlyType,
    })),
  },
]

export interface ToolboxContainerProps {
  vm: QuestionsBuilderViewModel
  /**
   * Whether we're rendering before the legend has loaded.
   */
  isSkeleton?: boolean
}

export const ToolboxContainer = observer(function ToolboxContainer({
  vm,
  isSkeleton,
}: ToolboxContainerProps) {
  return (
    <Toolbox
      groups={groups}
      isDisabled={vm.isEditingDisabled}
      isSkeleton={isSkeleton}
      onAdd={vm.addFromToolbox}
      onDragStart={vm.startToolboxDrag}
      onDragEnd={vm.endDrag}
      testId={testId}
    />
  )
})
